import { getCurrentInstance, reactive, ref } from '@nuxtjs/composition-api';

import { BLoadingComponent } from 'buefy/types/components';
export default function useLoading() {
  const instance = getCurrentInstance()?.proxy;
  const component = ref<BLoadingComponent>();
  const openLoading = () => {
    component.value = instance!.$buefy.loading.open({});
  };
  const closeLoading = () => {
    component.value?.close();
  };
  return {
    openLoading,
    closeLoading,
  };
}
